import { QueryParamStorageService } from '../../../core/query-param-storage.service';

const bridge = new QueryParamStorageService(); // if, for some reason, we need to differentiate between pages, we can pass a prefix here
const pdpAttributes = bridge.captureAndStore(['facet_audience', 'facet_style', 'facet_motive']);
const mfeNames = ['der-tm-roundtrip-stage'];
let lang = document.documentElement.lang;

const appplyAttributesToMfe = () => {
    const mfeWidgets = document.querySelectorAll(mfeNames.join(', '));

    if (!mfeWidgets || mfeWidgets.length === 0) {
        return;
    }

    Object.entries(pdpAttributes).forEach(([key, val]) => {
        mfeWidgets.forEach((widget) => widget.setAttribute(`${key}`, val));
    });

    mfeWidgets.forEach((widget) => widget.setAttribute('lang', lang));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appplyAttributesToMfe);
} else {
    appplyAttributesToMfe();
}
